<template>
	<div id="app">
		<div class="logo">
			<!-- OLD LOGO
			<img src="/img/ak.png" class="left">
			<div>RageCrew<small>Gaming & Community</small></div>
			<img src="/img/ak.png" class="right"> 
			-->

			<img src="/img/logo5.png">
		</div>

		<div class="app">
			<Serverlist />

			<div class="content">
				<transition name="routing" mode="out-in">
					<keep-alive>
						<router-view />
					</keep-alive>
				</transition>
			</div>
			
			<Menu />
		</div>

		
		<div class="footer">
			<span class="privacy">
				<i class="fas fa-shield-check"></i>
				<a href="privacy.html" target="_blank"> Privacy Policy</a> — 
				<a href="terms.html" target="_blank"> Terms and Conditions</a>
			</span>
			Copyright 2022 | Powered by @CHROM
		</div>
	</div>
</template>

<script>
import Serverlist from "./components/Serverlist.vue";
import Menu from "./components/Menu.vue";

export default {
	name: "App",
	components: { Serverlist, Menu },
};
</script>

<style lang="scss">
html,
body {
	padding: 0px;
	margin: 0px;
	min-height: 100vh;
	font-family: "Open Sans";
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	overflow: hidden;
}

body {
	background-image: url("/img/bg.png");
	background-position: center;
	background-size: cover;
	display: flex;
	justify-content: center;
	align-items: center;
}

a {
	color: inherit;
	text-decoration: none;
}

* {
	box-sizing: border-box;
}

@mixin glass_block {
	padding: 25px;
	border-radius: 25px;
	overflow: hidden;
	background-color: rgba(0, 0, 0, 0.25);
	background: linear-gradient(
		135deg,
		rgba(0, 0, 0, 0.2) 0%,
		rgba(0, 0, 0, 0.5) 100%
	);
}

.logo {
	font-size: 84px;
	font-weight: 800;
	color: white;
	text-align: center;
	line-height: 1.2;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	width: 680px;

	img {
		width: 100%;
		display: block;
		min-width: 450px;
	}

	// img {
	// 	width: 120px;
	// 	margin: 10px;
	// 	position: relative;

	// 	&.left {
	// 		transform: scaleX(-1);
	// 		top: 10px;
	// 		left: 80px;
	// 	}
	// 	&.right {
	// 		top: 10px;
	// 		right: 80px;
	// 	}
	// }

	small {
		font-size: 26px;
		display: block;
		color: rgba(0, 0, 0, 0.4);
	}
}

.app {
	width: 680px;
	// min-height: 55vh;
	height: 530px;
	display: flex;
	justify-content: space-between;
	align-items: stretch;
	margin-top: 2vh;
	color: white;
	// margin-right: 5vw;
	position: relative;

	.serverlist {
		@include glass_block;
		// flex: 0 22%;
	}

	.content {
		// @include glass_block;
		padding: 0px;
		// flex: 0 63%;
		width: 100%;
		background: initial;

		.page {
			@include glass_block;
			min-height: 100%;
		}

		.routing-enter-active,
		.routing-leave-active {
			transition: 0.2s;
			// transform: translateY(100%);
		}
		.routing-enter, .routing-leave-to /* .fade-leave-active до версии 2.1.8 */ {
			// transform: translateY(100%);
			// opacity: 0;
			transform: scale(0.8);
			opacity: 0;
		}
	}

	.menu {
		@include glass_block;
		// flex: 0 9%;
	}
}

.footer {
	position: fixed;
	bottom: 0px;
	left: 0px;
	right: 0px;
	padding: 10px;
	font-size: 13px;
	font-weight: 300;
	text-align: center;
	color: rgba(255, 255, 255, 0.2);
	// opacity: 0.15;

	.privacy {
		display: block;
		color: rgba(255, 255, 255, 0.7);
		margin-bottom: 5px;
		cursor: pointer;
	}
}

@media screen and (max-height: 820px) {
	.logo img {
		width: 70vh;
	}
	.footer {
		display: none;
	}
}

@media screen and (max-width: 1200px) and (orientation: portrait) {
	html,
	body {
		overflow: auto;
	}
	body {
		display: block;
		padding: 4vw;
		box-sizing: border-box;
		background-attachment: fixed;
	}

	.app,
	.logo {
		width: 100%;
		display: block;
	}
	.logo img {
		width: initial;
		max-width: 100%;
		min-width: initial;
	}

	.app {
		height: initial;
		// display: flex;
		// flex-direction: row-reverse;
		// flex-wrap: wrap;

		.menu {
			position: initial;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: row;
			padding: 4vw;
			margin-top: 2vw;

			.top,
			.bottom {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			a {
				display: initial;
				margin: 0px 2vw;
				margin-bottom: 0px !important;

				i {
					// display: initial;
					font-size: 10vw;
				}

				span {
					font-size: 3vw;
				}
			}
		}
	}

	.footer {
		position: initial;
	}
}
</style>
